import ProfileMobilePageV2 from './ProfileMobilePageV2';
export default ProfileMobilePageV2;
